import { forwardRef } from 'react';
import { CommonFormField, CommonFormFieldProps } from './CommonFormField';
import { DatePicker, DatePickerProps, FooterButton } from '../DatePicker';
import { translate } from '../../helpers';

const FOOTER_BUTTONS: FooterButton[] = [
  FooterButton.Today,
  FooterButton.Yesterday,
  FooterButton.Past7Days,
  FooterButton.Past14Days,
  FooterButton.Past30Days,
];

export type CreatedAtFilterFieldProps = Omit<DatePickerProps, 'error'> &
  Pick<CommonFormFieldProps, 'required' | 'error' | 'loading'>;

export const CreatedAtFilterField = forwardRef<HTMLDivElement, CreatedAtFilterFieldProps>(
  (
    {
      required,
      error,
      'data-testId': dataTestId = 'CreatedAtFilterField',
      loading = false,
      ...datePickerProps
    },
    ref,
  ) => (
    <CommonFormField
      label={translate('filter.createdAt')}
      required={required}
      error={error}
      data-testid={dataTestId}
      loading={loading}
      ref={ref}
    >
      <DatePicker range footerButtons={FOOTER_BUTTONS} error={!!error} {...datePickerProps} />
    </CommonFormField>
  ),
);
